import { useContext } from "react";
import BusinessContext from "../../contexts/business-context";
import SlideInNotification from "../ui/slide-in-notification";

const FullScreenLayout = ({ children }) => {
  const { notificationContent } = useContext(BusinessContext);

  return (
    <>
      <div className="flex min-h-[100dvh] h-[100dvh] scrollbar-none relative">{children}</div>
      <SlideInNotification
        message={notificationContent.message}
        heading={notificationContent.header}
        icon={notificationContent.icon}
        isVisible={notificationContent.showNotification}
      />
    </>
  );
};

export default FullScreenLayout;
